import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';

import Product from './modules/product';
import Article from './modules/article';
import Video from './modules/video';
import Platform from './modules/platform';
import Order from './modules/order';
import TmpLogin from './modules/tmpLogin';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页',
        icon: 'house',
        // fillScreen: true, // 是否全屏
      },
    },
    Order,
    Product,
    Article,
    Video,
    Platform,
    TmpLogin,
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js